export default {
      id: "new-window-usage",
      viewBox: "0 0 25 25",
      url: "images/" + "sprite.svg#new-window-usage",
      toString: function () {
        return this.url;
      }
    }